import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const DentalProcedures: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-accent-medicines-pink-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            viewBox="0 0 15 11"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-16 h-16 fill-white"
                        >
                            <path d="M0.787889 2.5C0.787889 1.25781 1.7957 0.25 3.03789 0.25H12.0379C13.2801 0.25 14.2879 1.25781 14.2879 2.5V8.5C14.2879 9.74219 13.2801 10.75 12.0379 10.75H3.03789C1.7957 10.75 0.787889 9.74219 0.787889 8.5V2.5ZM4.91289 3.625V4.9375C4.91289 5.26562 5.14726 5.5 5.47539 5.5H6.60039C6.90508 5.5 7.16289 5.26562 7.16289 4.9375V3.625C7.16289 3.01562 6.64726 2.5 6.03789 2.5C5.40508 2.5 4.91289 3.01562 4.91289 3.625ZM9.03789 2.5C8.40508 2.5 7.91289 3.01562 7.91289 3.625V4.9375C7.91289 5.26562 8.14726 5.5 8.47539 5.5H9.60039C9.90508 5.5 10.1629 5.26562 10.1629 4.9375V3.625C10.1629 3.01562 9.64726 2.5 9.03789 2.5ZM1.91289 4.375V4.9375C1.91289 5.26562 2.14726 5.5 2.47539 5.5H3.60039C3.90508 5.5 4.16289 5.26562 4.16289 4.9375V4.375C4.16289 3.76562 3.64726 3.25 3.03789 3.25C2.40508 3.25 1.91289 3.76562 1.91289 4.375ZM3.03789 8.5C3.64726 8.5 4.16289 8.00781 4.16289 7.375V6.8125C4.16289 6.50781 3.90508 6.25 3.60039 6.25H2.47539C2.14726 6.25 1.91289 6.50781 1.91289 6.8125V7.375C1.91289 8.00781 2.40508 8.5 3.03789 8.5ZM4.91289 7.375C4.91289 8.00781 5.40508 8.5 6.03789 8.5C6.64726 8.5 7.16289 8.00781 7.16289 7.375V6.8125C7.16289 6.50781 6.90508 6.25 6.60039 6.25H5.47539C5.14726 6.25 4.91289 6.50781 4.91289 6.8125V7.375ZM9.03789 8.5C9.64726 8.5 10.1629 8.00781 10.1629 7.375V6.8125C10.1629 6.50781 9.90508 6.25 9.60039 6.25H8.47539C8.14726 6.25 7.91289 6.50781 7.91289 6.8125V7.375C7.91289 8.00781 8.40508 8.5 9.03789 8.5ZM10.9129 4.375V4.9375C10.9129 5.26562 11.1473 5.5 11.4754 5.5H12.6004C12.9051 5.5 13.1629 5.26562 13.1629 4.9375V4.375C13.1629 3.76562 12.6473 3.25 12.0379 3.25C11.4051 3.25 10.9129 3.76562 10.9129 4.375ZM12.0379 8.5C12.6473 8.5 13.1629 8.00781 13.1629 7.375V6.8125C13.1629 6.50781 12.9051 6.25 12.6004 6.25H11.4754C11.1473 6.25 10.9129 6.50781 10.9129 6.8125V7.375C10.9129 8.00781 11.4051 8.5 12.0379 8.5Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={<div className="font-700">{sectionName || 'Dental Procedures'}</div>}
                key="1"
            >
                <p className="mr-16 space-y-2">
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dental_procedures_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dental_procedures_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dental_procedures_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Table title background color:</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dental_procedures_table_heading_color || '#E4DEEB'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dental_procedures_table_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dental_procedures_table_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Table border color:</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dental_procedures_table_border_color || '#8064A2'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dental_procedures_table_border_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dental_procedures_table_border_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default DentalProcedures;
